module.exports = __webpack_public_path__ + "img/ic_notify.1b816c31.png";